// material-ui
import { Box, Divider, Stack, Typography, useMediaQuery } from '@mui/material';
import axios from 'axios';

// project import
import Profile from './Profile';
import Notification from './Notification';
import MobileSection from './MobileSection';
import { useGiraf } from 'giraf/index';
// Search removed — replaced with date + election countdown

import { CalendarOutlined, MessageOutlined, ThunderboltOutlined, WalletOutlined } from '@ant-design/icons';

import { useEffect, useState } from 'react';

const BalItem = ({ icon, label, children }) => (
  <Stack direction="column" spacing={0.15} alignItems="center" sx={{ userSelect: 'none' }}>
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ fontSize: '0.55rem', fontWeight: 600, letterSpacing: '0.04em', textTransform: 'uppercase' }}
    >
      {label}
    </Typography>
    <Stack direction="row" spacing={0.4} alignItems="center">
      {icon}
      <Box>{children}</Box>
    </Stack>
  </Stack>
);

const ELECTION_2027 = new Date(2027, 7, 10);

const pad = (n) => String(n).padStart(2, '0');

const HeaderContent = () => {
  const matchesXs = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const today = new Date();
  const dateStr = today.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });

  const { gHead } = useGiraf();
  const [balances, setBalances] = useState({ money_balance: 0, sms_credits: 0, ai_credits: 0 });
  useEffect(() => {
    const token = gHead?.AuthToken;
    const base = process.env.REACT_APP_API_URL;
    if (!token || !base) return;
    let active = true;
    const load = () => {
      axios
        .get(`${base}/wallet/summary`, { headers: { Authorization: token } })
        .then(({ data }) => {
          if (active && data?.data) setBalances(data.data);
        })
        .catch(() => {});
    };
    load();
    const id = setInterval(load, 30000); // refresh every 30s
    return () => {
      active = false;
      clearInterval(id);
    };
  }, [gHead]);
  const fmt = (n) => Number(n || 0).toLocaleString('en-KE', { maximumFractionDigits: 0 });

  const [electionCountdown, setElectionCountdown] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  useEffect(() => {
    const tick = () => {
      const diff = Math.max(0, ELECTION_2027 - new Date());
      setElectionCountdown({
        days: Math.floor(diff / 86400000),
        hours: Math.floor((diff / 3600000) % 24),
        minutes: Math.floor((diff / 60000) % 60),
        seconds: Math.floor((diff / 1000) % 60)
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <>
      {!matchesXs && (
        <Box sx={{ flex: 1 }}>
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Stack direction="row" spacing={0.5} alignItems="center">
              <CalendarOutlined style={{ fontSize: 14, color: '#888780' }} />
              <Typography variant="body2" fontWeight={600} color="text.primary">
                {dateStr}
              </Typography>
            </Stack>
            <Divider orientation="vertical" flexItem sx={{ my: 0.5 }} />
            <Typography variant="caption" color="text.disabled" sx={{ fontSize: '0.55rem', fontWeight: 600, whiteSpace: 'nowrap' }}>
              Election 2027 · {pad(electionCountdown.days)}d {pad(electionCountdown.hours)}h {pad(electionCountdown.minutes)}m{' '}
              {pad(electionCountdown.seconds)}s
            </Typography>
          </Stack>
        </Box>
      )}
      {matchesXs && <Box sx={{ width: '100%', ml: 1 }} />}

      {!matchesXs && (
        <Stack
          direction="row"
          divider={<Divider orientation="vertical" flexItem sx={{ my: 0.5, borderColor: 'divider' }} />}
          spacing={1.5}
          alignItems="center"
          sx={{ mr: 1.5 }}
        >
          <BalItem icon={<WalletOutlined style={{ fontSize: 16, color: '#639922' }} />} label="Wallet">
            <Stack direction="row" spacing={0.2} alignItems="baseline">
              <Typography variant="caption" color="text.disabled" sx={{ fontSize: '0.55rem', fontWeight: 600 }}>
                KES
              </Typography>
              <Typography variant="body2" fontWeight={700} color="text.primary">
                {fmt(balances.money_balance)}
              </Typography>
            </Stack>
          </BalItem>
          <BalItem icon={<MessageOutlined style={{ fontSize: 16, color: '#185FA5' }} />} label="SMS">
            <Typography variant="body2" fontWeight={700} color="text.primary">
              {fmt(balances.sms_credits)}
            </Typography>
          </BalItem>
          <BalItem icon={<ThunderboltOutlined style={{ fontSize: 16, color: '#BA7517' }} />} label="AI Credits">
            <Typography variant="body2" fontWeight={700} color="text.primary">
              {fmt(balances.ai_credits)}
            </Typography>
          </BalItem>
        </Stack>
      )}
      <Notification />
      {!matchesXs && <Profile />}
      {matchesXs && <MobileSection />}
    </>
  );
};

export default HeaderContent;
